import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import type {CheckoutProfileFormValues} from '../types/CheckoutProfileFormValuesSchema';

export function getCheckoutProfileMissingRequiredFields(profile: CheckoutProfileFormValues) {
  const paths: (string | number)[][] = [];

  if (profile.typeOfSale === 'INTERNAL') {
    return paths;
  }

  profile.payments?.methods.forEach((payment, index) => {
    if (payment.method === 'CASH' && isNilOrEmpty(payment.cashRegisterId)) {
      paths.push(['payments', 'methods', index, 'cashRegisterId']);
    }

    if (payment.method === 'BANK_TRANSFER') {
      if (isNil(payment.bankAccount)) {
        paths.push(['payments', 'methods', index, 'bankAccount']);
      }

      if (isNil(payment.maturityDays)) {
        paths.push(['payments', 'methods', index, 'maturityDays']);
      }
    }
  });

  if (
    profile.deposit?.isAllowed &&
    profile.deposit.methods?.includes('BANK_TRANSFER') &&
    isNil(profile.deposit.maturityDays)
  ) {
    paths.push(['deposit', 'maturityDays']);
  }

  return paths;
}
